import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { Notify } from "@/components/ui/notify";
import { useProducts } from "@/features/products/hooks";

interface Props {
  value: string | null;
  onChange: (productId: string) => void;
  /** Modo OP: produto vem da OP, seletor read-only. */
  readOnly?: boolean;
  /** Compacto (toolbar): só o seletor, sem rótulo (re-layout do sandbox). */
  compact?: boolean;
}

// Produto simulado do cenário. Trocar grava structureSnap.productId no
// rascunho; a rodada exibida é invalidada pelo orquestrador. Read-only no modo OP.
export function ProductSelect({ value, onChange, readOnly, compact }: Props) {
  const productsQuery = useProducts();
  const { data: products = [], isError, error, refetch } = productsQuery;
  const selected = products.find((p) => p.id === value);

  if (isError) {
    return (
      <Notify.QueryError
        error={error}
        onRetry={() => void refetch()}
        variant={compact ? "inline" : "card"}
      />
    );
  }

  if (readOnly) {
    if (compact) {
      return <span className="text-xs font-medium">{selected?.name ?? "—"}</span>;
    }
    return (
      <div className="space-y-1">
        <Label className="text-xs">Produto</Label>
        <p className="text-sm">{selected?.name ?? "—"}</p>
      </div>
    );
  }

  if (compact) {
    return (
      <Select
        id="sbx-product"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Produto simulado"
        className="h-8 w-auto min-w-[9rem] text-xs"
      >
        <option value="" disabled>
          Produto…
        </option>
        {products.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </Select>
    );
  }

  return (
    <div className="space-y-1">
      <Label htmlFor="sbx-product" className="text-xs">
        Produto
      </Label>
      <Select
        id="sbx-product"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Produto simulado"
      >
        <option value="" disabled>
          Selecione um produto…
        </option>
        {products.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </Select>
    </div>
  );
}
